import {Extent} from "ol/extent";
import {Coordinate} from "ol/coordinate";
import {MapFishPrint as MPF} from "../map-fish-print";

export function pageExtent(pageFeatureCenter: Coordinate, scale: number, layout: MPF.ILayout): Extent {
    const inchesPerMetre = 1000 / 25.4;

    // from GeoEXT
    const width = (layout.map.width) / 72 / inchesPerMetre * scale / 2;
    const height = (layout.map.height) / 72 / inchesPerMetre * scale / 2;

    const [x, y] = pageFeatureCenter;

    const l = x - width;
    const r = x + width;
    const t = y + height;
    const b = y - height;

    return [l, b, r, t];
}